import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  children: {
    exporter: {
      size: 'full',
      path: 'exporter',
    },
    contactId: {
      size: 'full',
      path: ':contactId',
      children: {
        edit: {
          size: 'full',
          path: 'edit',
        },
        overview: {
          size: 'full',
          path: 'overview',
        },
        projects: {
          size: 'full',
          path: 'projects',
        },
        purchaseOrders: {
          size: 'full',
          path: 'purchase-orders',
        },
        invoices: {
          size: 'full',
          path: 'invoices',
        },
        documents: {
          size: 'full',
          path: 'documents',
        },
      },
    },
  },
} as const satisfies Pick<Location, 'children'>
